import { Dialog } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

const PaymentFailDialog = ({ onDismiss, onClick }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      aria-label="Payment Fail Message"
      onDismiss={onDismiss}
      title={t("Button.updatePayment")}
      description={t("Payment.PaymentFailDialog.description")}
      primaryAction={onClick}
    />
  )
}

export default PaymentFailDialog
